<template>
    <div class="px-3 px-md-2 pt-3 pt-md-0 pb-1">

    <div v-if="loading" class="text-center py-3"><i class="fas fa-spinner fa-spin"></i></div>

      <p v-else-if="views.length == 0" class="pt-3 text-center">No data</p>

        <div v-else>

          <!-- Desktop -->
          <table class="table datatables-basic d-none d-md-table mt-3">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3">Words</th>
                  <th class="first-right px-3">Count</th>
                </tr>
              </thead>
          <tbody>
            <tr class="body2" v-for="(view, index) in views" :key="index.id">
              <td class="pl-3"><a :href="`/search/${view.query.toLowerCase()}`" target="_blank">{{view.query.toLowerCase()}}</a></td>
              <td class="pl-3">{{view.searches}}</td>
            </tr>
          </tbody>
        </table>

        <!-- Mobile -->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">Words • Count</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(view, index) in views" :key="index">
  
        <td class="pl-2">
            <div>{{view.query}}</div>
            <div>{{view.searches}}</div>
        </td>

            </tr>
          </tbody>
        </table>

        </div>


  </div>
</template> 

<script>
export default {
  data() {
    return {
      views: [],
      tabIndex: 0,
      loading: false,
    };
  },

  created() {
    this.getViews();

    // Echo.private("views")
    //   .listen("NewView", (event) => {
    //     this.getViews();
    //   });
  },

  methods: {

    getViews() {
      this.loading = true;

      axios.post(`/top-searches`)
      .then((response) => {
        this.views = response.data;
        this.loading = false;
      });
      
    },
  },
};
</script>